export function heroSlider() {
    const slider = document.querySelector("#hero-slider");
    if (!slider) return;

    const slides = slider.querySelectorAll(".hero-slide");
    if (slides.length <= 1) return;

    let current = 0;
    let loopCount = 0;
    const maxLoops = 2; // na 2 volledige loops stopt hij
    const fadeDuration = 1;
    const slideDelay = 5;
    const overlap = 1;
    const startScale = 1.1; // 👈 subtielere zoom

    gsap.set(slides, { opacity: 0 });
    gsap.set(slides[0], { opacity: 1 });
    slides[0].classList.add("active");

    const firstImg = slides[0].querySelector("img");
    gsap.fromTo(
        firstImg,
        { scale: startScale },
        { scale: 1, duration: slideDelay + fadeDuration, ease: "power3.out" }
    );

    const nextSlide = () => {
        const next = (current + 1) % slides.length;
        const currentSlide = slides[current];
        const nextSlide = slides[next];
        const nextImg = nextSlide.querySelector("img");

        const tl = gsap.timeline({
            defaults: { duration: fadeDuration, ease: "power3.inOut" }
        });

        // Crossfade slides
        tl.to(currentSlide, { opacity: 0 }, 0)
          .fromTo(
              nextSlide,
              { opacity: 0 },
              {
                  opacity: 1,
                  onStart: () => {
                      nextSlide.classList.add("active");
                      gsap.fromTo(
                          nextImg,
                          { scale: startScale },
                          { scale: 1, duration: slideDelay + fadeDuration, ease: "power3.out" }
                      );
                  }
              },
              `-=${fadeDuration * overlap}`
          )
          .add(() => currentSlide.classList.remove("active"), ">");

        current = next;

        // Check of we opnieuw bij slide 0 zijn → dan 1 loop afgerond
        if (current === 0) {
            loopCount++;

            if (loopCount >= maxLoops) {
                clearInterval(interval);

                // Na maxLoops: blijf op eerste slide
                gsap.to(slides, { opacity: 0, duration: fadeDuration });
                gsap.to(slides[0], { opacity: 1, duration: fadeDuration });

                slides.forEach(slide => slide.classList.remove("active"));
                slides[0].classList.add("active");
            }
        }
    };

    const interval = setInterval(nextSlide, slideDelay * 1000);
}
